module.exports = __webpack_public_path__ + "static/media/titulo4.d6fe9063.png";